import { mutateGraphQL } from '~/hooks/graphql.js';

const LoginWithCookiesMutation = `
  mutation Login($login: String!, $password: String!, $captchaToken: String!) {
		loginWithCookies(input: { login: $login, password: $password, captchaToken: $captchaToken }) {
			status
		}
	}
`;

/**
 * mutateGraphQL returns a callback method.
 *
 * { 'login', 'password' } 
 */
export const getLoginMutationHandler = () => {
	const refetchQueries = [
		// { query: GetCurrentUserDataQuery }
	];
  const { mutationHandler } = mutateGraphQL(LoginWithCookiesMutation, refetchQueries);

  return { mutationHandler };
}
